module.exports = __webpack_public_path__ + "img/cr.7920dae7.svg";